//页面内按钮权限控制
const check=(val,sval)=>{
    let item=sessionStorage.getItem(val)
    if(item){
        if(item.indexOf(sval)>-1){
            return true
        }else{
            return false
        }
    }else{
        return false
    }
}
export default{
    check
}